import Http from './http'
// 方法调用日志
export const logMethod = (target, key, descriptor) => {
	const method = descriptor.value
	descriptor.value = (...args) => {
		console.log(`${key}方法调用`)
		return method.apply(target, args)
	}
	return descriptor
}
// 注入http
export const AutowiredHttp = (target, key, descriptor) => {target.ajaxInstance = Http}


// WEBPACK FOOTER //
// ./src/utils/AutoWrite.js